'use strict';

class UtilityBar extends HTMLElement {
  constructor() {
    super();

    this.slides       = [];
    this.currentIndex = 0;
    this.timer        = null;
    this.autoplay     = false;
    this.speed        = 4000;

    // Stable references required for removeEventListener
    this._onMouseEnter    = ()  => this.pause();
    this._onMouseLeave    = ()  => this.resume();
    this._onFocusIn       = ()  => this.pause();
    this._onFocusOut      = (e) => { if (!this.contains(e.relatedTarget)) this.resume(); };
    this._onBlockSelect   = (e) => this._handleBlockSelect(e);
    this._onBlockDeselect = ()  => { if (this.autoplay) this.play(); };
    this._onSectionLoad   = ()  => this._init();
  }

  connectedCallback() {
    document.addEventListener('shopify:section:load',    this._onSectionLoad);
    document.addEventListener('shopify:block:select',    this._onBlockSelect);
    document.addEventListener('shopify:block:deselect',  this._onBlockDeselect);
    this._init();
  }

  disconnectedCallback() {
    this.pause();
    this._unbind();
    document.removeEventListener('shopify:section:load',   this._onSectionLoad);
    document.removeEventListener('shopify:block:select',   this._onBlockSelect);
    document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
  }

  _init() {
    this.slides       = Array.from(this.querySelectorAll('.utility-bar__slide'));
    this.currentIndex = 0;

    this.pause();
    this._unbind();

    if (this.slides.length <= 1) return;

    this.autoplay = this.dataset.autoplay === 'true';
    this.speed    = (parseInt(this.dataset.speed, 10) || 4) * 1000;

    this._bind();
    if (this.autoplay) this.play();
  }

  _bind() {
    const prev = this.querySelector('.utility-bar__nav--prev');
    const next = this.querySelector('.utility-bar__nav--next');

    if (prev) prev.addEventListener('click', () => { this.prev(); this._resetTimer(); });
    if (next) next.addEventListener('click', () => { this.next(); this._resetTimer(); });

    this.addEventListener('mouseenter', this._onMouseEnter);
    this.addEventListener('mouseleave', this._onMouseLeave);
    this.addEventListener('focusin',    this._onFocusIn);
    this.addEventListener('focusout',   this._onFocusOut);
  }

  _unbind() {
    this.removeEventListener('mouseenter', this._onMouseEnter);
    this.removeEventListener('mouseleave', this._onMouseLeave);
    this.removeEventListener('focusin',    this._onFocusIn);
    this.removeEventListener('focusout',   this._onFocusOut);
  }

  _resetTimer() {
    if (!this.autoplay) return;
    this.pause();
    this.play();
  }

  goTo(index) {
    const outgoing = this.slides[this.currentIndex];
    outgoing.classList.remove('utility-bar__slide--active');
    outgoing.setAttribute('aria-hidden', 'true');

    this.currentIndex = (index + this.slides.length) % this.slides.length;

    const incoming = this.slides[this.currentIndex];
    incoming.classList.add('utility-bar__slide--active');
    incoming.setAttribute('aria-hidden', 'false');
  }

  next() { this.goTo(this.currentIndex + 1); }
  prev() { this.goTo(this.currentIndex - 1); }

  play() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), this.speed);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
  }

  resume() {
    if (this.autoplay && !this.timer) this.play();
  }

  _handleBlockSelect(event) {
    const index = this.slides.indexOf(event.target);
    if (index === -1) return;
    this.pause();
    this.goTo(index);
  }
}

if (!customElements.get('utility-bar')) {
  customElements.define('utility-bar', UtilityBar);
}
